import PopupMessage from './PopupMessage-redux';

export default PopupMessage;
